import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'
import { queryString } from '../../utils/queryString'

export const withdrawSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getWithdraws: build.query({
      query: ({ page = 1, limit = 10 }) => {
        const qs = queryString({ page, limit })
        console.log(qs)
        return `${urlConfig.walletsBaseUrl}/wallets/withdraws?${qs}`
      },
      transformResponse: (response: any, meta, args) => ({
        ...response,
        per_page: args.limit,
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Withdraws' as const,
                id: _id,
              })),
              { type: 'Withdraws', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Withdraws', id: 'PARTIAL-LIST' }],
    }),

    getWithdrawById: build.query<any, any>({
      query: id => `${urlConfig.walletsBaseUrl}/wallets/withdraws/${id}`,
    }),

    getWithdrawStats: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/withdraws/stats`,
    }),

    // Pre-OTP dry-run: validates everything (balance, limits, bank supported
    // by the current payout provider) without changing state, so errors show
    // before the OTP prompt. No-op for the backend if skipped (createWithdraw
    // re-validates), so it's safe/backward-compatible.
    validateWithdraw: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/withdraws/validate`,
        method: 'POST',
        body,
      }),
    }),

    createWithdraw: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/withdraws`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Withdraws'],
    }),

    createWithdrawWithOtp: build.mutation({
      query: ({ body, challengeId, otpCode }) => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/withdraws`,
        method: 'POST',
        body,
        headers: {
          'x-otp-challenge': challengeId,
          'x-otp-code': otpCode,
        },
      }),
      invalidatesTags: ['Withdraws'],
    }),
  }),
})

export const {
  useGetWithdrawsQuery,
  useGetWithdrawByIdQuery,
  useValidateWithdrawMutation,
  useCreateWithdrawMutation,
  useCreateWithdrawWithOtpMutation,
  useGetWithdrawStatsQuery,
} = withdrawSlice
